import React from 'react';

export default function Loading({ text = "Loading...", fullPage = false }) {
    return (
        <div className={fullPage ? "d-flex justify-content-center align-items-center vh-100" : "d-flex justify-content-center align-items-center"} style={fullPage ? { minHeight: '100vh' } : {}}>
            <div className="text-center">
                <div className="spinner-border text-success" role="status" style={{ width: "3rem", height: "3rem" }}>
                    <span className="sr-only">Loading...</span>
                </div>
                {text && <div className="mt-2 text-white">{text}</div>}
            </div>
        </div>
    );
}
